module.exports = __webpack_public_path__ + "img/qy (4).97df0826.jpg";